import { Edit2, Trash2 } from 'lucide-react';

/**
 * Edit and delete buttons at the end of a table row.
 */
export default function RowActions({
  label,
  onEdit,
  onDelete,
}: {
  label: string;
  onEdit: () => void;
  onDelete: () => void;
}) {
  return (
    <td style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
      <div style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
        <button
          className="icon-btn"
          onClick={onEdit}
          title={`Edit ${label}`}
          aria-label={`Edit ${label}`}
          style={{ width: 28, height: 28 }}
        >
          <Edit2 size={13} />
        </button>
        <button
          className="icon-btn btn-danger"
          onClick={onDelete}
          title={`Delete ${label}`}
          aria-label={`Delete ${label}`}
          style={{ width: 28, height: 28 }}
        >
          <Trash2 size={13} />
        </button>
      </div>
    </td>
  );
}

